module.exports = __webpack_public_path__ + "item_4.svg?514a7d8a9b79e0b1613188b5abaaf8a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item_4.svg
// module id = 27
// module chunks = 0